module.exports = __webpack_public_path__ + "static/img/27.791eb4d9.png";